export const CONTACT_INFO_MAX_AGE_DAYS = 365;

const E164_PHONE_REGEX = /^\+[0-9]{7,15}$/;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

type ContactInfoUser = {
  contact_info_updated_date_utc?: string | null;
  phone?: string;
  preferred_email?: string;
};

export function isContactInfoStale(user: ContactInfoUser | undefined | null): boolean {
  if (!user) {
    return false;
  }

  if (!user.contact_info_updated_date_utc) {
    return true;
  }

  if (!user.phone) {
    return true;
  }

  if (!user.preferred_email) {
    return true;
  }

  const updatedAtMs = Date.parse(user.contact_info_updated_date_utc);
  if (Number.isNaN(updatedAtMs)) {
    return true;
  }

  const nowMs = Date.now();
  const maxAgeMs = CONTACT_INFO_MAX_AGE_DAYS * 24 * 60 * 60 * 1000;
  const ageMs = nowMs - updatedAtMs;

  return ageMs > maxAgeMs;
}

export function isValidE164Phone(value: string): boolean {
  return E164_PHONE_REGEX.test(value);
}

export function isValidEmail(value: string): boolean {
  return EMAIL_REGEX.test(value);
}
